import App from './App'

const canvas = document.querySelector('.webgl')
const app = new App(canvas)
